import _ from 'lodash';
import { spmfcloudPostalFunctionUrl } from '../../../actions/salesforces';

export const findLabel = (fieldName, objectDescribe) => {
    let labelName = '';
    objectDescribe.map((fieldDescription) => {
        if (fieldDescription.name === fieldName) labelName = fieldDescription.label;
    });
    return labelName;
};

export const findField = (fieldName, objectDescribe) => {
    let fieldInfo = {};
    objectDescribe.map((fieldDescription) => {
        if (fieldDescription.name === fieldName) fieldInfo = fieldDescription;
    });
    return fieldInfo;
};

export const getPostaCodeOptions = (input, callback) => {
    let url = '';
    if (window.__DEV__) {
        url = `${spmfcloudPostalFunctionUrl}/api/getPostalCode/${input || 0}`;
    } else {
        url = `${spmfcloudPostalFunctionUrl}/api/getPostalCode/${input || 0}`;
    }

    fetch(url, {
        mode: 'cors',
        cache: 'no-cache',
        method: 'GET',
    }).then(response => response.json())
        .then((json) => {
            let options = [{ value: input, label: input, type: 'new_postal' }];
            if (typeof json.data === 'string') {
                callback(options);
                return;
            }
            options = json.data.map((postalItem) => {
                const cloneItem = {
                    ...postalItem,
                };
                cloneItem.value = postalItem.POSTCODE;
                cloneItem.label = postalItem.POSTCODE;
                return cloneItem;
            });
            callback(options);
        })
        .catch(console.error);
};

export default null;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/actions/common.js
// module id = 85
// module chunks = 0